import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ImageWithFallback extends Vue {

  @Prop()
  src!: string;

  @Prop()
  fallbackTitle!: string;

  @Prop({
    default: false,
  })
  isSmall!: boolean;

  @Prop({
    default: null,
  })
  maxWidth!: string|null;

  isFallbackNecessary: boolean = false;

  get imageName(): string {
    return this.src.substr(this.src.lastIndexOf('/') + 1);
  }

  get style(): object {
    return {
      maxWidth: this.maxWidth ? `${this.maxWidth}px` : 'auto',
    };
  }

  onImageLoadError(): void {
    this.isFallbackNecessary = true;
  }

}
